import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toggle-buttons";
import "./../../bindings/element";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import InformationViewModel from "./../information";
class InformationTagTab {
    TabPage;
    infoVM: KnockoutObservable<InformationViewModel>;
    Template = ko.observable("");
    TemplateContext = ko.observable(null);
    DirtyFlag: KnockoutObservable<boolean>;
    IsHistory = ko.observable(false);
    TagValues = ko.observableArray([]);
    /** the dom-element which defines to area for rendering tags
     */
    RenderElement = ko.observable();
    constructor(infoVM: InformationViewModel, tabPage: any) {
        this.TabPage = tabPage;
        this.infoVM = ko.observable(infoVM);
        this.infoVM().SubTabsSaveFn.push(() => { return this.Save(); });
        this.infoVM().SubTabsCompleteCheckFn.push(() => { return this.CompleteCheck(); });
        this.DirtyFlag = this.infoVM().TabPage.DirtyFlag;
        this.IsHistory(this.StringIsNullOrEmpty(this.infoVM().InfoHistoryId()));
        // when a new Info will be loaded, call Event (onNewInfoLoaded)
        this.infoVM().InfoId.subscribe(() => { this.onNewInfoLoaded(); });
        this.infoVM().InfoHistoryId.subscribe(() => {
            this.UpdateValues();
        });
    }
    /** Event wich will be invoked, if parents-info is loaded/changed (its PK-ID)
     */
    onNewInfoLoaded() {
        this.TabPage.IsLoading(true);
        this.TagList([]);
        //this.TagValues([]);
        this.Template(null);
        this.init()
            .always(() => {
            this.TabPage.IsLoading(false);
        });
    }
    TagList = ko.observableArray<{
        IsWriteTag: boolean;
        TagId: string;
        UniversalFieldTypeId: string;
        IsMandatory: boolean;
        Options: string[];
    }>();
    SetTagValueByTagId(tagId, numericValue, booleanValue, textValue, valueHtml) {
        let tagvallist = ko.unwrap(this.TagValues);
        if (tagvallist === null) {
            return;
        }
        for (let i in tagvallist) {
            if (ko.unwrap(tagvallist[i].TagId) === tagId) {
                if (tagvallist[i] != null) {
                    tagvallist[i].NumericValue(numericValue);
                    tagvallist[i].BooleanValue(booleanValue);
                    tagvallist[i].TextValue(textValue);
                    tagvallist[i].TagValueHtml(valueHtml);
                }
                this.TagValues(tagvallist);
                return;
            }
        }
    }
    ;
    StringIsNullOrEmpty(string) {
        // solange die funktion noch nicht voll funktionstüchtig ist(#108283)
        //return Bao.Utils.String.IsNullOrEmpty(string);
        // nutze eigene Implementierung
        if (string === null)
            return true;
        else if (string === "")
            return true;
        else if (typeof string === "undefined")
            return true;
        return false;
    }
    ;
    /**
     *
     * @returns jQueryPromise<bool>
     */
    CompleteCheck() {
        let taglist = this.TagList();
        if (taglist === null || typeof taglist === "undefined") {
            return true;
        }
        for (let index in taglist) {
            let currTag = taglist[index];
            if (currTag.IsMandatory === true) {
                let tagValue = this.getTagObservable(currTag.TagId);
                if (tagValue === null) {
                    return false;
                }
                switch (currTag.UniversalFieldTypeId.toLowerCase()) {
                    case "b3f7d21b-56dc-4258-91ba-00f0d64cb2b2": //Optionsfelder
                        if (this.StringIsNullOrEmpty(tagValue.TextValue()))
                            return false;
                        break;
                    case "c694105e-3356-4fd9-a702-682e2e18520c": //Alphanumerisch
                        if (this.StringIsNullOrEmpty(tagValue.TextValue()))
                            return false;
                        break;
                    case "1eb0ef5b-07bd-476c-8415-d32931cd6bca": //Numerisch
                        if (this.StringIsNullOrEmpty(tagValue.NumericValue()))
                            return false;
                        break;
                    case "6c4865b4-3e87-4f64-be09-9e461e88550a": //Ja/Nein
                        if (this.StringIsNullOrEmpty(tagValue.BooleanValue()))
                            return false;
                        break;
                    case "0fc89eed-9510-4094-a0a8-835cee0a3f24": //Auswahl mit Suchdialog
                        if (this.StringIsNullOrEmpty(tagValue.TextValue()))
                            return false;
                        break;
                    case "02dd5bf9-f182-4368-917e-dd053ee2f4a7": //Auswahl Drop-Down
                        if (this.StringIsNullOrEmpty(tagValue.TextValue())) {
                            return false;
                        }
                        else {
                            //Sonderprüfung für DropDown TagType - falls pflichtfeld darf wert != 1.Option sein
                            if (currTag.Options.length > 0) {
                                if (currTag.Options[0] == tagValue.TextValue()) {
                                    return false;
                                }
                            }
                        }
                        break;
                    case "e2a64241-6766-4159-81d7-257da36327bb": // DateTimePicker
                        if (this.StringIsNullOrEmpty(tagValue.DateTimeValueJs()))
                            return false;
                        break;
                    case "8de0ffb8-1250-4322-85ee-2a64c46bbb78": // Searchdialog with searchobject
                        if (this.StringIsNullOrEmpty(tagValue.TextValue()))
                            return false;
                        break;
                    case "b453e0de-0f88-4f22-bfff-a0189f6a117b": // Text area
                        if (this.StringIsNullOrEmpty(tagValue.TextValue()))
                            return false;
                        break;
                    case "523c8fc3-b4f5-4ac9-8af7-ad883b7f8255": // checkbox
                        if (this.StringIsNullOrEmpty(tagValue.BooleanValue()))
                            return false;
                        break;
                }
            }
        }
        return true;
    }
    /**
     * return true if no changes made, saveallowed is false or is history
     */
    canClose(): JQueryPromise<boolean> | boolean {
        if (this.IsHistory() || this.infoVM().SaveAllowed() == false) {
            return true;
        }
        else if (this.DirtyFlag()) {
            return false;
        }
        else {
            return true;
        }
    }
    CloseReport() {
        return this.Close();
    }
    // save this form - no need to check mandatory fields - the parent invokes CompleteCheck when closing report.
    Save() {
        this.TabPage.IsLoading(true);
        return Bao.post("InformationUniversalFieldsTab/Save", JSON.stringify({
            tagValues: ko.map.toJS(this.TagValues()),
            reportId: this.infoVM().ReportId(),
            infoId: this.infoVM().InfoId(),
            infoHistoryId: this.infoVM().InfoHistoryId()
        }))
            .then((result) => {
            this.DirtyFlag(false);
            return this.UpdateValues();
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }
    Close() {
        this.TabPage.IsLoading(true);
        let def = $.Deferred();
        Bao.post("InformationUniversalFieldsTab/Close", JSON.stringify({ tagValues: ko.map.toJS(this.TagValues()), infoId: this.infoVM().InfoId(), infoHistoryId: this.infoVM().InfoHistoryId() }), (result) => {
            this.DirtyFlag(false);
            this.UpdateValues().then(() => {
                this.TabPage.IsLoading(false);
                def.resolve();
            });
        });
        return def.promise();
    }
    init() {
        // load latest version
        return this.UpdateTab();
    }
    /**
     * Updates template and values - discards changes
     */
    UpdateTab() {
        this.Template(null);
        this.TemplateContext(null);
        return Bao.post("InformationUniversalFieldsTab/Template", JSON.stringify({
            reportId: this.infoVM().ReportId(),
            infoId: this.infoVM().InfoId(),
            infoHistoryId: this.infoVM().InfoHistoryId()
        })).then((result) => {
            this.TagList(result.model);
            return this.UpdateValues()
                .then(() => {
                Bao.Templates["InformationUniversalFields" + this.infoVM().ReportId()] = result.html;
                this.Template("InformationUniversalFields" + this.infoVM().ReportId());
            });
        });
    }
    UpdateValues(version?) {
        return Bao.post("InformationUniversalFieldsTab/GetValues", JSON.stringify({
            reportId: this.infoVM().ReportId(),
            infoId: this.infoVM().InfoId(),
            infoHistoryId: this.infoVM().InfoHistoryId()
        }), (model) => {
            ko.map.fromJS(model, this, this.DirtyFlag);
            this.TemplateContext(this);
        });
    }
    /**
     * get value
     * @param tagId
     */
    getTagObservable(tagId) {
        let obs = null;
        ko.utils.arrayForEach(this.TagValues(), (item) => {
            if (ko.unwrap(item.TagId) == tagId) {
                obs = item;
            }
        });
        return obs;
    }
    /**
     * get tag
     * @param tagId
     */
    getTagModel(tagId) {
        let obs = null;
        ko.utils.arrayForEach(this.TagList(), (item) => {
            if (ko.unwrap(item.TagId) == tagId) {
                obs = item;
            }
        });
        return obs;
    }
    pauseDirtyFlag() {
        this.TabPage.DirtyFlag.pause();
    }
    resumeDirtyFlag() {
        this.TabPage.DirtyFlag.resume();
    }
}
export default InformationTagTab;